import { useEffect, useState } from "react";

export interface IInputPops {
  type?: string;
  name: string;
  id?: string;
  value?: string;
  readonly?: boolean;
  styles?: string;
  dataType?: string;
  updateAble?: string;
  placeholder?: string;
}

export default function Input({
  type = "text",
  name,
  id,
  value,
  readonly,
  dataType = "",
  updateAble = "false",
  styles,
  placeholder,
}: IInputPops) {
  const [inValue, setInValue] = useState("");

  useEffect(() => {
    if (value) {
      setInValue(value);
    }
  }, [value]);

  return (
    <input
      type={type}
      name={name}
      id={id}
      placeholder={placeholder}
      value={inValue}
      className={styles}
      readOnly={readonly}
      autoComplete="off"
      data-type={dataType}
      data-update={updateAble}
      onFocus={(e) => {
        const { update } = e.currentTarget.dataset;
        if (update === "true") {
          e.currentTarget.setAttribute("data-type", "U");
        }
      }}
      onChange={(e) => {
        setInValue(e.currentTarget.value);
      }}
    />
  );
}
